import { Component, Input, NgModule } from '@angular/core';

@Component({
  selector: 'dk-user-avatar',
  templateUrl: './user-avatar.component.html',
  styleUrls: ['./user-avatar.component.scss'],
  standalone: true,
  imports: [],
})
export class UserAvatarComponent {
  @Input() dataLetters: string | null;
}
